import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

export default function MapFocusHandler({
    mapFocus,
    situacao,
    selectedPoint,
    lastPosition,
    mapReady,
    plannedTrajeto,
    pezinho
}) {

    const map = useMap();

    const lastRequestRef = useRef(null);

    // ========================================
    // FOCUS
    // ========================================

    useEffect(() => {

        if (!mapReady || !mapFocus) {
            return;
        }

        const requestId = mapFocus.requestId;

        if (!requestId) {
            return;
        }

        // já processou essa solicitação
        if (lastRequestRef.current === requestId) {
            return;
        }

        // aguarda trajeto estar disponível
        if (
            mapFocus.type === 'bounds' &&
            !plannedTrajeto?.length
        ) {
            return;
        }

        // aguarda posição estar disponível
        if (
            mapFocus.type === 'vehicle' &&
            (
                lastPosition?.latitude == null ||
                lastPosition?.longitude == null
            )
        ) {
            return;
        }

        const frameId = requestAnimationFrame(() => {

            // request válido e pronto para executar
            lastRequestRef.current = requestId;

            switch (mapFocus.type) {

                case 'point':

                    map.setView(
                        [
                            Number(mapFocus.lat),
                            Number(mapFocus.lng)
                        ],
                        mapFocus.zoom ?? map.getZoom(),
                        {
                            animate: false
                        }
                    );

                    break;

                case 'pezinho-position':

                    map.setView(
                        [
                            Number(mapFocus.lat),
                            Number(mapFocus.lng)
                        ],
                        mapFocus.zoom ?? 17,
                        {
                            animate: false
                        }
                    );

                    break;

                case 'bounds':

                    map.fitBounds(
                        plannedTrajeto,
                        {
                            padding: [30, 30],
                            animate: false
                        }
                    );

                    break;

                case 'vehicle':

                    map.setView(
                        [
                            Number(lastPosition.latitude),
                            Number(lastPosition.longitude)
                        ],
                        mapFocus.zoom ?? 17,
                        { 
                            animate: false 
                        }
                    );

                    break;

                default:
                    break;
            }

        });

        return () => {
            cancelAnimationFrame(frameId);
        };

    }, [
        map,
        mapReady,
        mapFocus,
        plannedTrajeto,
        lastPosition
    ]);

    // ========================================
    // AUTO FOLLOW VEHICLE
    // ========================================

    useEffect(() => {

        if (pezinho.active) {
            return;
        }

        if (situacao !== 'Em andamento') {
            return;
        }

        if (
            lastPosition?.latitude == null ||
            lastPosition?.longitude == null
        ) {
            return;
        }

        if (selectedPoint) {
            return;
        }

        if (mapFocus?.type !== 'vehicle') {
            return;
        }

        map.panTo(
            [
                Number(lastPosition.latitude),
                Number(lastPosition.longitude)
            ],
            {
                animate: false,
            }
        );

    }, [
        map,
        lastPosition,
        selectedPoint,
        mapFocus?.type,
        situacao,
        pezinho.active
    ]);

    return null;
}